export default "__VITE_ASSET__11e924bb__"